import React from "react";
import { Icon } from "@iconify/react";

const DashboardIcon = () => (
  <Icon icon="lucide:layout-dashboard" width={18} height={18} />
);

export default DashboardIcon;
